export * from "./hotel-reserve-booking-card-detial";
